import { combineReducers } from 'redux-immutable';
import settingsReducer from './settingsReducer';
import authReducer from './authReducer';
// eslint-disable-next-line import/no-cycle
import shoppingReducer from './shoppingReducer';
import bookingReducer from '../Booking/ManageBooking/reducersManageBooking';
import customerAccountReducer from '../CustomerAccounts/reducersCustomerAccount';

const rootReducer = combineReducers({
	settings: settingsReducer,
	shopping: shoppingReducer,
	booking: bookingReducer,
	auth: authReducer,
	customerAccount: customerAccountReducer,
});

export default rootReducer;
